<style lang="less">
  .anchorBL{ display: none !important;}
  .editor{
    img{ width: auto; height: auto; max-width: 100%; }
    p{ margin-bottom: inherit; }
  }
  #detail{
    border-color: #d9d9d9 !important; 
    border: 1px solid #d9d9d9;
    width: 100%;
    border-collapse: collapse;
    table-layout: fixed;
  }
  #detail td {
    padding: 10px;
    vertical-align: top;
    line-height: 25px;
  }
  #detail{
    text-align: center; 
    background-color: var(--card-bg, #fff);
    min-width: 80px;
    border-collapse: collapse;
    box-shadow: none;
  }
  #detail td {
    padding: 12px 16px;
    vertical-align: top;
    line-height: 1.8;
  }
  /* 标签列：固定宽度，右对齐 */
  #detail .tdHeader {
    width: 140px;
    min-width: 100px;
    text-align: right;
    padding-right: 20px;
    font-weight: 500;
    white-space: nowrap;
    background-color: var(--color-fill-2, #f7f8fa);
  }
  /* 值列：左对齐 */
  #detail td:not(.tdHeader) {
    text-align: left;
  }
  .detail-images-wrap {
    display: flex; gap: 6px; align-items: center; flex-wrap: wrap;
  }
  .image-more-count {
    display: inline-flex; align-items: center; justify-content: center;
    min-width: 48px; height: 48px; padding: 0 4px;
    font-size: 12px; color: #86909c;
    background: var(--color-fill-2); border-radius: 4px;
  }
  /* 去掉图片底色 */
  #detail img,
  #detail .arco-image,
  #detail [class*="image"] {
    background-color: transparent !important;
    background: none !important;
  }
</style>

<template>
  <div class="fan fan-component" ref="printBody">
    <a-spin v-if="!ready" tip="加载中..." />
    <table v-else id="detail" border="1">
      <tr v-for="i in Math.ceil(fieldList.length / detailCols)" :key="'r'+i">
        <template v-for="j in detailCols" :key="'c'+j">
          <template v-if="getColKey(i, j)">
            <td class="tdHeader">{{ getColName(i, j) }}</td>
            <td>
              <template v-if="hasValue(getColKey(i, j))">
                <template v-if="getColType(i, j) === 'user'">{{ getDataVal(i, j).name || '默认名称' }}</template>
                <template v-else-if="isImageForm(i, j)">
                  <a-image width="64" height="64" :src="getDataVal(i, j)" fit="cover" style="border-radius:6px;cursor:pointer;" />
                </template>
                <template v-else-if="getColForm(i, j) === 'images'">
                  <div class="detail-images-wrap">
                    <template v-for="(img, imgIdx) in parseImageUrls(getDataVal(i, j))" :key="imgIdx">
                      <a-image
                        v-if="imgIdx < 6"
                        width="56" height="56"
                        :src="img" fit="cover"
                        style="border-radius:4px;cursor:pointer;"
                      />
                    </template>
                    <span v-if="parseImageUrls(getDataVal(i, j)).length > 6" class="image-more-count">
                      +{{ parseImageUrls(getDataVal(i, j)).length - 6 }}
                    </span>
                  </div>
                </template>
                <template v-else-if="getColForm(i, j) === 'file'"><a-button><icon-download />附件</a-button></template>
                <template v-else-if="isBoolForm(i, j)">{{ getDataVal(i, j) ? '√' : '×' }}</template>
                <template v-else-if="isSelectForm(i, j)">{{ $fan.page.getOptionName(getColKey(i, j), getDataVal(i, j)) || '未找到值' }}</template>
                <template v-else-if="getColForm(i, j) === 'selectMultiple'"><a-tag v-for="tag in getDataVal(i, j)" :key="tag">{{ $fan.page.getOptionName(getColKey(i, j), tag) || tag }}</a-tag></template>
                <template v-else-if="getColForm(i, j) === 'mapPoint'">地图坐标：{{ getDataVal(i, j).x || '' }},{{ getDataVal(i, j).y || '' }}</template>
                <template v-else-if="isEditorForm(i, j)"><div v-html="getDataVal(i, j)"></div></template>
                <template v-else-if="getColForm(i, j) === 'numberWithUnit'">{{ getDataVal(i, j) }} {{ getNumUnitName(i, j) }}</template>
                <template v-else-if="isDateForm(i, j)">{{ formatDateVal(i, j) }}</template>
                <template v-else>{{ getDataVal(i, j) }}<template v-if="getColUnit(i, j)"> {{ getColUnit(i, j) }}</template></template>
              </template>
              <template v-else>暂无数据</template>
            </td>
          </template>
        </template>
      </tr>
    </table>
    <form ref="pdf" action="http://pdf.119.7jj.org.cn/" method="POST" target="_blank" v-show="false">
      <input type="hidden" name="payload" :value="page?.printData || ''" />
    </form>
  </div>
</template>

<script>
  import ZCodeEditor from 'vue-json-editor'
  import { IconDownload } from '@arco-design/web-vue/es/icon'
  import moment from 'moment'

  export default {
    name: 'ZDetail',
    components: { ZCodeEditor, IconDownload },
    props: { superData: Object },
    created() { this.page = this.$fan.utils.parse(this.def.page) },
    watch: {
      superData: {
        handler(newVal) {
          if (newVal) {
            this.ready = false
            this.$nextTick(async () => { await this.loadData(); this.ready = true; this.$forceUpdate() })
          }
        },
        immediate: true
      }
    },
    computed: {
      detailCols() { return this.fieldList.length > 10 ? 2 : 1 },
      fieldList() { return Object.keys(this.columns) },
      columns() {
        const cols = {}
        for (let k in this.data.columns) {
          const c = this.data.columns[k]
          if (!c.hidden || c.hidden.indexOf('detail') < 0) cols[k] = c
        }
        return cols
      }
    },
    data() {
      return { page: { loading: { page: false }, printData: '' }, ready: false, def: { page: { loading: { page: false } } }, data: { columns: {}, options: {}, data: {} } }
    },
    methods: {
      // ====== 辅助方法（避免模板中复杂表达式）======
      getColKey(row, col) { return this.fieldList[this.detailCols * (row - 1) + (col - 1)] || '' },
      getColName(row, col) { const k = this.getColKey(row, col); return (this.columns[k] && this.columns[k].name) || k },
      getCol(row, col) { return this.columns[this.getColKey(row, col)] || {} },
      getColType(row, col) { return this.getCol(row, col).type },
      getColForm(row, col) { return this.getCol(row, col).form },
      getDataVal(row, col) { return this.data.data[this.getColKey(row, col)] },
      hasValue(fk) { const v = this.data.data[fk]; return (v !== undefined && v !== null && v !== '') || v === false || v === 0 },
      isImageForm(row, col) { return ['esign','image','esignbm','imagebm'].includes(this.getColForm(row, col)) },
      isBoolForm(row, col) { return ['bool','switch'].includes(this.getColForm(row, col)) },
      isSelectForm(row, col) { return ['select','cascader','selectTree','radio','linkSelect'].includes(this.getColForm(row, col)) },
      getColUnit(row, col) { return this.getCol(row, col).unit || '' },
      getNumUnitName(row, colIdx) {
        var c = this.getCol(row, colIdx)
        const unitField = c.unitField || (this.getColKey(row, colIdx) + '_unit')
        const unitId = this.data.data[unitField]
        if (unitId == null || unitId === '') return ''
        var keyinfo = (this.data && this.data.keyinfo) || {}
        const uInfo = (keyinfo[unitField] && keyinfo[unitField][unitId])
        return uInfo ? uInfo.name : ''
      },
      isEditorForm(row, col) { return ['editor','quilleditor'].includes(this.getColForm(row, col)) },
      isDateForm(row, col) { return ['datepicker', 'monthpicker', 'yearpicker', 'quarterpicker', 'datetimepicker', 'weekpicker'].includes(this.getColForm(row, col)) },
      formatDateVal(row, col) {
        const form = this.getColForm(row, col)
        const fmtMap = { datepicker: 'YYYY-MM-DD', monthpicker: 'YYYY-MM', yearpicker: 'YYYY', quarterpicker: 'YYYY-[Q]Q', datetimepicker: 'YYYY-MM-DD HH:mm:ss', weekpicker: 'YYYY-WW' }
        const fmt = fmtMap[form] || 'YYYY-MM-DD'
        const v = this.getDataVal(row, col)
        if (v === null || v === undefined || v === '') return ''
        const m = moment(v)
        return m.isValid() ? m.format(fmt) : String(v)
      },
      parseImageUrls(val) {
        if (Array.isArray(val)) return val.filter(v => v && (typeof v === 'string'))
        if (!val) return []
        if (typeof val === 'string') {
          if (val.indexOf('http') === 0) return [val]
          try { const parsed = JSON.parse(val); return Array.isArray(parsed) ? parsed.filter(v => v) : [] }
          catch { return [] }
        }
        return []
      },
      async loadData() {
        this.page.loading.page = true
        const data = this.$store.state.page
        this.data = this.$fan.utils.parse(data)
        this.data.data = this.superData || {}
        this.page.loading.page = false
      },
      async actionDetailPrint() {
        const domDetail = await this.$refs.printBody.innerHTML
        const print = require('@/public/utils/print').default
        print(domDetail)
      },
      bindDownload(url) { window.open(url, '_blank') }
    }
  }
</script>
